import * as React from 'react';
import {withTranslation} from 'react-i18next';
import * as ContractModule from "Modules/ContractModule";
import {compose} from "redux";
import {connect} from "react-redux";
import {RootState} from "Redux/Reducers/_RootReducer";
import {Types} from "Models/ContractModel";
import ContractSingleDto = Types.ContractSingleDto;
import TurnOffCarForm from "components/CarsManagement/TurnOffCarForm";
import ChangeOffDateBody = Types.ChangeOffDateBody;
import * as ErrorActions from "Redux/Actions/ErrorActions";
import {EnumTypes as ErrorEnumType} from "Models/EnumTypes/ErrorEnumTypes";
import i18n from "Translations/_i18n";
import * as ViewManagementModule from "Modules/ViewManagementModule";
import {history} from "HelperFunctions/root";
import * as Dictionary from "Models/Dictionary";

type Props = {
    history?: any;
    match: any;
};

type ConnectedProps = {
    currentContractNumber: string;
    contractList: Array<ContractSingleDto>;
    t?: Function;
};


type DispatchedP = {
    changeOffDate: (contractId: number, formData: ChangeOffDateBody) => void;
    showInfoBox: Function;
};

type State = {
    currentContract: ContractSingleDto;
};

class ChangeOffDate extends React.Component<Props & ConnectedProps & DispatchedP, State> {
    constructor(props: Props & ConnectedProps & DispatchedP) {
        super(props);
        this.state = {
            currentContract: this.props.contractList.find(element => element.contractNumber === this.props.currentContractNumber)
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public async handleSubmit(formData: ChangeOffDateBody) {
        try {
            await this.props.changeOffDate(this.state.currentContract?.id, formData);
            this.props.showInfoBox(ErrorEnumType.NewsType.SUCCESS, 'Pomyślnie zmieniono datę wyłączenia SIM');
            history.push(`${Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.CONTRACT_MANAGEMENT)}`);
        } catch (e) {
            this.props.showInfoBox(ErrorEnumType.NewsType.ERROR, e);
            // console.log(e);
        }
    }

    public render() {
        const {t} = this.props;

        return (
            <div className="main__content main__content--scroll" data-testid="change-off-date">
                <h3 className="main__title">
                    Zmiana daty wyłączenia karty SIM
                </h3>
                <div className="font-xmd">
                    Numer umowy: <span className="bold">{this.state.currentContract?.contractNumber}</span>
                    <br/>
                    VIN: <span className="bold">{this.state.currentContract?.vin}</span>
                </div>

                <div className="flex flex--space-around mt-55">
                    <div className="report report-manual">
                        <p className="report-manual__title">{t('dictionary:INSTRUCTION')}</p>
                        <ol className="report-manual__list">
                            <li className="report-manual__list-item"
                                dangerouslySetInnerHTML={{__html: t('turnOffStep1')}}/>
                            <li className="report-manual__list-item"
                                dangerouslySetInnerHTML={{__html: t('turnOffStep2')}}/>
                            <li className="report-manual__list-item"
                                dangerouslySetInnerHTML={{__html: t('turnOffStep3')}}/>
                        </ol>
                    </div>

                    <TurnOffCarForm initialValues={{plannedEndDate: this.state.currentContract?.plannedEndDate}} dateOnly
                                    onSubmit={this.handleSubmit} dateInputName="plannedEndDate"/>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        currentContractNumber: state.contractStore.contractNumberActive,
        contractList: state.contractStore.contractList
    };
}


function mapDispatchToProps(dispatch: any): DispatchedP {
    return {
        changeOffDate: (contractId: number, formData: ChangeOffDateBody) => dispatch(ContractModule.Actions.changePlannedEndDate(contractId, formData)),
        showInfoBox: (type, message) => dispatch(ErrorActions.setNewsForMoment({type, message}))
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation(['carDetails', 'forms', 'dictionary']))(ChangeOffDate) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/Contract/ChangeOffDate.tsx